import axios from "axios";
import Cookies from "js-cookie";

const BASE_URL = "https://web.bernardopolo.com/bp_api";
//En caso de emergengia levantar contenedores de servidor visitaecuador y usar estas ruta de base
//const BASE_URL = "https://visitaecuador.com/bp_api";

const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

api.interceptors.request.use(
    (config) => {
        const token = Cookies.get("accessToken");
        if (token) {
            config.headers = config.headers || {};
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;